<template>
	<UnidadeLayout>
		<LoaderPage v-if="loadingPage" />
		<main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-min-h-screen">
			<div class="tw-mx-auto tw-max-w-7xl tw-px-4 md:tw-px-6 tw-py-6 tw-space-y-6">

				<div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 sm:tw-justify-between sm:tw-items-center">
					<div>
						<h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-black tw-tracking-tight">
							Consulta Avançada
						</h2>
						<p class="tw-text-sm tw-text-gray-500 tw-mt-0.5">
							Filtre os silos de várias unidades por nível, produto, temperatura e aeração.
						</p>
					</div>
					<router-link
						to="/v2/unidades"
						:class="theme === 'dark' ? 'tw-bg-zinc-800 hover:tw-bg-zinc-700 tw-text-white' : 'tw-bg-slate-900 hover:tw-bg-slate-800 tw-text-white'"
						class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-shadow-sm tw-whitespace-nowrap tw-self-start sm:tw-self-auto"
					>
						<i class="fa-solid fa-arrow-left"></i>
						<span>Minhas Unidades</span>
					</router-link>
				</div>

				<section :class="cardClass" class="tw-rounded-2xl tw-shadow-2xl tw-p-4 md:tw-p-6">
					<div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-3 tw-mb-5">
						<div class="tw-flex tw-items-center tw-gap-3">
							<div :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'" class="tw-p-2.5 tw-rounded-xl">
								<i class="fa-solid fa-sliders tw-text-lg tw-w-5 tw-text-center"></i>
							</div>
							<div>
								<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Parâmetros da consulta</h3>
								<p class="tw-text-xs tw-text-gray-500">Mostrar os silos que atendem a todas as condições</p>
							</div>
						</div>
						<button
							type="button"
							@click="addParametroConsulta()"
							class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white"
						>
							<i class="fa-solid fa-plus"></i> Adicionar parâmetro
						</button>
					</div>

					<button
						v-if="parametrosConsulta.length === 0"
						type="button"
						@click="addParametroConsulta()"
						:class="theme === 'dark' ? 'tw-border-slate-700 tw-text-slate-400 hover:tw-bg-white/5' : 'tw-border-slate-300 tw-text-slate-500 hover:tw-bg-slate-100'"
						class="tw-w-full tw-text-center tw-py-8 tw-rounded-xl tw-border-2 tw-border-dashed"
					>
						<i class="fa-solid fa-magnifying-glass tw-text-2xl tw-opacity-50 tw-mb-2"></i>
						<p class="tw-font-semibold tw-text-sm">Nenhum parâmetro configurado</p>
						<p class="tw-text-xs tw-mt-1">Sem parâmetros, a consulta lista todos os silos das unidades selecionadas</p>
					</button>

					<div v-else class="tw-space-y-3">
						<div
							v-for="(parametro, index) in parametrosConsulta"
							:key="index"
							:class="theme === 'dark' ? 'tw-bg-slate-800/60' : 'tw-bg-slate-100'"
							class="tw-rounded-xl tw-p-3 tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-3"
						>
							<div class="tw-flex tw-items-center tw-justify-between md:tw-justify-start">
								<span
									:class="index === 0
										? (theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200' : 'tw-bg-white tw-text-slate-700')
										: 'tw-bg-emerald-500 tw-text-white'"
									class="tw-inline-flex tw-items-center tw-justify-center tw-min-w-[64px] tw-px-3 tw-py-2 tw-rounded-lg tw-text-xs tw-font-bold tw-uppercase"
								>
									{{ index === 0 ? 'Silos' : 'E' }}
								</span>
								<button
									type="button"
									@click="removerParametro(index)"
									:class="theme === 'dark' ? 'hover:tw-bg-red-500/10 tw-text-red-400' : 'hover:tw-bg-red-50 tw-text-red-600'"
									class="md:tw-hidden tw-p-2 tw-rounded-lg"
									title="Remover parâmetro"
								>
									<i class="fa-solid fa-trash-can"></i>
								</button>
							</div>
							<div class="tw-grid tw-grid-cols-[7rem_1fr] md:tw-flex md:tw-flex-1 md:tw-items-center tw-gap-3 tw-min-w-0">
								<div class="md:tw-w-28 tw-shrink-0">
									<BaseSelect v-model="parametro.que_ou_quenao" :options="queOptions" option-label="label" option-value="value" />
								</div>
								<div class="tw-min-w-0 md:tw-flex-1 md:tw-max-w-sm">
									<BaseSelect v-model="parametro.tipo" :options="tipoOptions" option-label="label" option-value="value" placeholder="Selecione um parâmetro" />
								</div>
								<input
									v-if="TIPOS_COM_VALOR.includes(parametro.tipo)"
									v-model.number="parametro.valor"
									type="number"
									min="0"
									placeholder="Valor"
									:class="inputClass"
									class="tw-col-span-2 md:tw-w-28 tw-px-3 tw-py-2.5 tw-rounded-lg tw-text-sm"
								/>
								<input
									v-if="parametro.tipo === 'data=='"
									v-model="data"
									type="datetime-local"
									:class="inputClass"
									class="tw-col-span-2 md:tw-w-auto tw-px-3 tw-py-2.5 tw-rounded-lg tw-text-sm"
								/>
								<div v-if="parametro.tipo === 'produto_=='" class="tw-col-span-2 md:tw-w-44">
									<BaseSelect v-model="parametro.valor" :options="produtoOptions" placeholder="Produto" searchable />
								</div>
							</div>
							<button
								type="button"
								@click="removerParametro(index)"
								:class="theme === 'dark' ? 'hover:tw-bg-red-500/10 tw-text-red-400' : 'hover:tw-bg-red-50 tw-text-red-600'"
								class="tw-hidden md:tw-inline-flex tw-p-2 tw-rounded-lg tw-ml-auto"
								title="Remover parâmetro"
							>
								<i class="fa-solid fa-trash-can"></i>
							</button>
						</div>
					</div>
				</section>

				<div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-6">
					<!-- Unidades -->
					<section :class="cardClass" class="lg:tw-col-span-2 tw-rounded-2xl tw-shadow-2xl tw-p-4 md:tw-p-6">
						<div class="tw-flex tw-items-center tw-gap-3 tw-mb-5">
							<div :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'" class="tw-p-2.5 tw-rounded-xl">
								<i class="fa-solid fa-warehouse tw-text-lg tw-w-5 tw-text-center"></i>
							</div>
							<div class="tw-flex-1">
								<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Unidades</h3>
								<p class="tw-text-xs tw-text-gray-500">{{ unidadesSelecionadas.length }} de {{ unidades.length }} selecionada(s)</p>
							</div>
						</div>
						<div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 tw-mb-4">
							<div class="tw-flex-1 tw-min-w-0">
								<BaseSelect
									:model-value="null"
									@update:modelValue="adicionarUnidade"
									:options="unidadesDisponiveis"
									option-label="nome"
									option-value="id"
									placeholder="Adicionar unidade..."
									searchable
								/>
							</div>
							<div class="tw-grid tw-grid-cols-2 sm:tw-flex tw-gap-2">
								<button
									type="button"
									@click="selecionarTodasUnidades"
									:class="theme === 'dark' ? 'tw-bg-slate-800 hover:tw-bg-slate-700 tw-text-slate-100' : 'tw-bg-slate-200 hover:tw-bg-slate-300 tw-text-slate-800'"
									class="tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-whitespace-nowrap"
								>
									Selecionar todas
								</button>
								<button
									type="button"
									@click="limparUnidades"
									:disabled="unidadesSelecionadas.length === 0"
									:class="theme === 'dark' ? 'hover:tw-bg-white/5 tw-text-slate-300' : 'hover:tw-bg-slate-100 tw-text-slate-600'"
									class="tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-whitespace-nowrap disabled:tw-opacity-40"
								>
									Limpar
								</button>
							</div>
						</div>
						<div :class="theme === 'dark' ? 'tw-bg-black/20' : 'tw-bg-slate-100'" class="tw-p-3 tw-rounded-xl tw-min-h-[64px] tw-max-h-56 tw-overflow-y-auto custom-scrollbar tw-flex tw-flex-wrap tw-gap-2 tw-content-start">
							<p v-if="unidadesSelecionadas.length === 0" class="tw-w-full tw-text-center tw-text-sm tw-text-gray-500 tw-py-2">
								Nenhuma unidade selecionada
							</p>
							<span
								v-for="unidade in unidadesSelecionadas"
								:key="unidade.id"
								:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-100' : 'tw-bg-white tw-text-slate-800 tw-shadow-sm'"
								class="tw-inline-flex tw-items-center tw-gap-2 tw-pl-3 tw-pr-1.5 tw-py-1.5 tw-rounded-lg tw-text-sm tw-font-medium tw-max-w-full"
							>
								<span class="tw-truncate">{{ unidade.nome }}</span>
								<button type="button" @click="removerUnidade(unidade.id)" class="tw-p-1 tw-rounded hover:tw-text-red-500" title="Remover">
									<i class="fa-solid fa-xmark tw-text-xs"></i>
								</button>
							</span>
						</div>
					</section>

					<!-- Colunas -->
					<section :class="cardClass" class="tw-rounded-2xl tw-shadow-2xl tw-p-4 md:tw-p-6">
						<div class="tw-flex tw-items-center tw-gap-3 tw-mb-5">
							<div :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400' : 'tw-bg-amber-50 tw-text-amber-600'" class="tw-p-2.5 tw-rounded-xl">
								<i class="fa-solid fa-table-columns tw-text-lg tw-w-5 tw-text-center"></i>
							</div>
							<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Colunas exibidas</h3>
						</div>
						<div class="tw-grid tw-grid-cols-2 lg:tw-grid-cols-1 tw-gap-2">
							<label
								v-for="col in COLUNAS"
								:key="col.key"
								:class="theme === 'dark' ? 'hover:tw-bg-white/5' : 'hover:tw-bg-slate-100'"
								class="tw-flex tw-items-center tw-gap-2.5 tw-px-2 tw-py-1.5 tw-rounded-lg tw-cursor-pointer"
							>
								<input type="checkbox" v-model="colunasTable[col.key]" class="tw-w-4 tw-h-4 tw-accent-[#33b35a]">
								<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">{{ col.label }}</span>
							</label>
						</div>
					</section>
				</div>

				<div class="tw-flex sm:tw-justify-end">
					<button
						type="button"
						@click="executarConsulta()"
						class="tw-w-full sm:tw-w-auto tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-[#33b35a] hover:tw-bg-[#2d9d4f] tw-text-white tw-px-8 tw-py-3 tw-rounded-xl tw-font-bold tw-shadow-lg tw-shadow-green-600/20"
					>
						<i class="fa-solid fa-magnifying-glass"></i>
						Executar consulta
					</button>
				</div>

				<!-- Resultado -->
				<section v-if="consultaFeita" :class="cardClass" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
					<div class="tw-p-4 md:tw-p-6 tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b" :class="theme === 'dark' ? 'tw-border-white/5' : 'tw-border-slate-200'">
						<div class="tw-flex tw-items-center tw-gap-3">
							<div :class="theme === 'dark' ? 'tw-bg-green-500/10' : 'tw-bg-green-50'" class="tw-p-2.5 tw-rounded-xl">
								<i class="fa-solid fa-list-check tw-text-green-500 tw-text-lg tw-w-5 tw-text-center"></i>
							</div>
							<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Resultado</h3>
						</div>
						<span :class="theme === 'dark' ? 'tw-bg-green-500/15 tw-text-green-400' : 'tw-bg-green-50 tw-text-green-700'" class="tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-bold tw-whitespace-nowrap">
							{{ totalSilos }} silo(s)
						</span>
					</div>

					<div v-if="resultUnidadesWithSilos.length < 1" class="tw-text-center tw-py-14 tw-px-4">
						<i class="fa-solid fa-database tw-text-4xl tw-opacity-30 tw-mb-3"></i>
						<h4 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-semibold">Nenhum silo encontrado</h4>
						<p class="tw-text-sm tw-text-gray-500 tw-mt-1">Revise os parâmetros e execute a consulta novamente.</p>
					</div>

					<div v-else :class="theme === 'dark' ? 'tw-divide-white/5' : 'tw-divide-slate-200'" class="tw-divide-y">
						<div v-for="unidade in resultUnidadesWithSilos" :key="unidade.id">
							<div :class="theme === 'dark' ? 'tw-bg-black/20' : 'tw-bg-slate-100/70'" class="tw-px-4 md:tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-3">
								<i class="fa-solid fa-building tw-text-gray-400"></i>
								<h4 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-bold tw-text-sm md:tw-text-base tw-flex-1 tw-min-w-0 tw-truncate">{{ unidade.nome }}</h4>
								<span class="tw-text-xs tw-font-semibold tw-text-gray-500 tw-whitespace-nowrap">{{ unidade.silos.length }} silo(s)</span>
							</div>

							<div class="tw-hidden md:tw-block tw-overflow-x-auto">
								<table class="tw-w-full tw-text-left">
									<thead>
										<tr>
											<th class="tw-px-6 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Local</th>
											<th v-if="colunasTable.produto" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Produto</th>
											<th v-if="colunasTable.data_ultimo_registro" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Último registro</th>
											<th v-if="colunasTable.nivel" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Nível</th>
											<th v-if="colunasTable.media_atual" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Média</th>
											<th v-if="colunasTable.status_motores" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Motores</th>
											<th v-if="mostrarSensoresOff" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Sensores OFF</th>
											<th v-if="mostrarSensoresMatch" class="tw-px-4 tw-py-3 tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Sensores</th>
											<th class="tw-px-6 tw-py-3"></th>
										</tr>
									</thead>
									<tbody :class="theme === 'dark' ? 'tw-divide-white/5' : 'tw-divide-slate-100'" class="tw-divide-y">
										<tr v-for="silo in unidade.silos" :key="silo.id" :class="theme === 'dark' ? 'hover:tw-bg-white/[0.03]' : 'hover:tw-bg-slate-50'">
											<td :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-px-6 tw-py-3.5 tw-text-sm tw-font-semibold tw-whitespace-nowrap">{{ silo.nome }}</td>
											<td v-if="colunasTable.produto" class="tw-px-4 tw-py-3.5 tw-text-sm">{{ silo.ultima_leitura.produto }}</td>
											<td v-if="colunasTable.data_ultimo_registro" class="tw-px-4 tw-py-3.5 tw-text-sm tw-text-gray-500 tw-whitespace-nowrap tw-tabular-nums">{{ silo.ultima_leitura.data }}</td>
											<td v-if="colunasTable.nivel" class="tw-px-4 tw-py-3.5 tw-min-w-[140px]">
												<div class="tw-flex tw-items-center tw-justify-between tw-text-sm tw-mb-1">
													<span class="tw-font-semibold">{{ Number(silo.nivel).toFixed(1) }}%</span>
													<span class="tw-text-xs tw-text-gray-500">{{ sacas(silo) }}</span>
												</div>
												<div :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-200'" class="tw-h-1.5 tw-rounded-full tw-overflow-hidden">
													<div class="tw-h-full tw-bg-emerald-500 tw-rounded-full" :style="{ width: Math.min(100, silo.nivel) + '%' }"></div>
												</div>
											</td>
											<td v-if="colunasTable.media_atual" class="tw-px-4 tw-py-3.5 tw-text-sm tw-font-bold tw-whitespace-nowrap" :style="{ color: getCorPorTemperatura(silo.media_atual) }">{{ silo.media_atual }}°C</td>
											<td v-if="colunasTable.status_motores" class="tw-px-4 tw-py-3.5">
												<span v-if="!silo.aeracao" class="tw-text-sm tw-text-gray-500">Sem aeração</span>
												<div v-else class="tw-flex tw-flex-wrap tw-gap-1.5">
													<span v-for="motor in silo.aeracao.motores" :key="motor.id" :class="motorClass(motor)" class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-lg tw-border tw-text-xs tw-font-semibold tw-whitespace-nowrap">
														<i :class="motor.status == 1 ? 'fa-solid fa-fan fa-spin' : 'fa-solid fa-fan tw-opacity-50'"></i>
														{{ motor.descricao }}
													</span>
												</div>
											</td>
											<td v-if="mostrarSensoresOff" class="tw-px-4 tw-py-3.5">
												<button v-if="totalSensoresOff(silo) > 0" @mouseenter="abrirPopover('off', silo, $event)" @mouseleave="agendarFechamentoPopover" @click="abrirPopover('off', silo, $event)" :class="theme === 'dark' ? 'tw-bg-red-500/15 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-700'" class="tw-px-2.5 tw-py-1 tw-rounded-lg tw-text-xs tw-font-bold tw-whitespace-nowrap">
													{{ totalSensoresOff(silo) }} sensor(es) OFF
												</button>
											</td>
											<td v-if="mostrarSensoresMatch" class="tw-px-4 tw-py-3.5">
												<button v-if="totalSensoresMatch(silo) > 0" @mouseenter="abrirPopover('match', silo, $event)" @mouseleave="agendarFechamentoPopover" @click="abrirPopover('match', silo, $event)" :class="theme === 'dark' ? 'tw-bg-amber-500/15 tw-text-amber-300' : 'tw-bg-amber-50 tw-text-amber-800'" class="tw-px-2.5 tw-py-1 tw-rounded-lg tw-text-xs tw-font-bold tw-whitespace-nowrap">
													{{ totalSensoresMatch(silo) }} sensor(es)
												</button>
											</td>
											<td class="tw-px-6 tw-py-3.5 tw-text-right">
												<button @click="openInNewTab(unidade.id, silo.id)" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400 hover:tw-bg-blue-500/20' : 'tw-bg-blue-50 tw-text-blue-700 hover:tw-bg-blue-100'" class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-whitespace-nowrap">
													Acessar <i class="fa-solid fa-arrow-up-right-from-square tw-text-[10px]"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div :class="theme === 'dark' ? 'tw-divide-white/5' : 'tw-divide-slate-100'" class="md:tw-hidden tw-divide-y">
								<div v-for="silo in unidade.silos" :key="'m-' + silo.id" class="tw-p-4 tw-space-y-3">
									<div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
										<span :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-semibold tw-text-sm tw-min-w-0 tw-truncate">{{ silo.nome }}</span>
										<button @click="openInNewTab(unidade.id, silo.id)" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-700'" class="tw-shrink-0 tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold">
											Acessar <i class="fa-solid fa-arrow-up-right-from-square tw-text-[10px]"></i>
										</button>
									</div>
									<div class="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-text-sm">
										<div v-if="colunasTable.produto">
											<span class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Produto</span>
											{{ silo.ultima_leitura.produto }}
										</div>
										<div v-if="colunasTable.media_atual">
											<span class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Média</span>
											<span class="tw-font-bold" :style="{ color: getCorPorTemperatura(silo.media_atual) }">{{ silo.media_atual }}°C</span>
										</div>
										<div v-if="colunasTable.data_ultimo_registro" class="tw-col-span-2">
											<span class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Último registro</span>
											<span class="tw-text-gray-500 tw-tabular-nums">{{ silo.ultima_leitura.data }}</span>
										</div>
										<div v-if="colunasTable.nivel" class="tw-col-span-2">
											<div class="tw-flex tw-items-center tw-justify-between tw-mb-1">
												<span class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Nível</span>
												<span><span class="tw-font-semibold">{{ Number(silo.nivel).toFixed(1) }}%</span> <span class="tw-text-xs tw-text-gray-500">· {{ sacas(silo) }}</span></span>
											</div>
											<div :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-200'" class="tw-h-1.5 tw-rounded-full tw-overflow-hidden">
												<div class="tw-h-full tw-bg-emerald-500 tw-rounded-full" :style="{ width: Math.min(100, silo.nivel) + '%' }"></div>
											</div>
										</div>
										<div v-if="colunasTable.status_motores" class="tw-col-span-2">
											<span class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-mb-1">Motores</span>
											<span v-if="!silo.aeracao" class="tw-text-gray-500">Sem aeração</span>
											<div v-else class="tw-flex tw-flex-wrap tw-gap-1.5">
												<span v-for="motor in silo.aeracao.motores" :key="motor.id" :class="motorClass(motor)" class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-lg tw-border tw-text-xs tw-font-semibold">
													<i :class="motor.status == 1 ? 'fa-solid fa-fan fa-spin' : 'fa-solid fa-fan tw-opacity-50'"></i>
													{{ motor.descricao }}
												</span>
											</div>
										</div>
										<div v-if="(mostrarSensoresOff && totalSensoresOff(silo) > 0) || (mostrarSensoresMatch && totalSensoresMatch(silo) > 0)" class="tw-col-span-2 tw-flex tw-flex-wrap tw-gap-2">
											<button v-if="mostrarSensoresOff && totalSensoresOff(silo) > 0" @click="abrirPopover('off', silo, $event)" :class="theme === 'dark' ? 'tw-bg-red-500/15 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-700'" class="tw-px-2.5 tw-py-1 tw-rounded-lg tw-text-xs tw-font-bold">
												{{ totalSensoresOff(silo) }} sensor(es) OFF
											</button>
											<button v-if="mostrarSensoresMatch && totalSensoresMatch(silo) > 0" @click="abrirPopover('match', silo, $event)" :class="theme === 'dark' ? 'tw-bg-amber-500/15 tw-text-amber-300' : 'tw-bg-amber-50 tw-text-amber-800'" class="tw-px-2.5 tw-py-1 tw-rounded-lg tw-text-xs tw-font-bold">
												{{ totalSensoresMatch(silo) }} sensor(es)
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</main>
		<Teleport to="body">
			<div
				v-if="popover"
				ref="popover"
				:style="popoverStyle"
				@mouseenter="cancelarFechamentoPopover"
				@mouseleave="agendarFechamentoPopover"
				:class="theme === 'dark' ? 'tw-bg-slate-900 tw-border-slate-700' : 'tw-bg-white tw-border-slate-300'"
				class="tw-fixed tw-z-[999] tw-p-3 tw-rounded-xl tw-border tw-text-xs tw-shadow-2xl tw-overflow-y-auto tw-transition-none"
			>
				<template v-if="popover.tipo === 'off'">
					<div v-for="(sensores, cabo) in popover.silo.sensores_off" :key="cabo" :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-mb-1 tw-text-center">
						<strong>Cabo {{ cabo }}:</strong> {{ sensores.join(', ') }}
					</div>
				</template>
				<template v-else>
					<div v-for="(sensores, cabo) in popover.silo.sensores_match" :key="cabo" :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-mb-1">
						<strong>Cabo {{ cabo }}:</strong>
						<div class="tw-flex tw-flex-wrap tw-gap-1 tw-mt-1">
							<span
								v-for="sensor in sensores"
								:key="sensor.sensor"
								:class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-100' : 'tw-bg-slate-100 tw-text-slate-800'"
								class="tw-inline-flex tw-items-center tw-gap-1.5 tw-pl-1.5 tw-pr-2 tw-py-1 tw-rounded-md tw-text-xs tw-tabular-nums"
							>
								<span class="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-shrink-0" :style="{ backgroundColor: getCorPorTemperatura(sensor.temperatura) }"></span>
								<span class="tw-opacity-60">{{ sensor.sensor }}</span>
								<span class="tw-font-bold">{{ sensor.temperatura }}°C</span>
							</span>
						</div>
					</div>
				</template>
			</div>
		</Teleport>
	</UnidadeLayout>
</template>
<script>
import temperaturaCores from "@/assets/colors.json";
import UnidadeLayout from "@/components/layouts/v2/UnidadeLayout.vue";
import LoaderPage from "@/components/ui/v2/LoaderPage.vue";
import BaseSelect from "@/components/ui/v2/BaseSelect.vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useToast } from 'vue-toastification';

export default {
	name: "ConsultaAvancadaPage",
	components: {
		UnidadeLayout,
		LoaderPage,
		BaseSelect,
	},
	methods: {
		totalSensoresOff(silo) {
			return Object.values(silo.sensores_off || {}).reduce((acc, sensores) => acc + sensores.length, 0);
		},
		totalSensoresMatch(silo) {
			return Object.values(silo.sensores_match || {}).reduce((acc, sensores) => acc + sensores.length, 0);
		},
		sacas(silo) {
			const capacidade = parseInt(silo.capacidade) || 0;
			return `${parseInt((silo.nivel / 100) * capacidade).toLocaleString('pt-BR')} / ${capacidade.toLocaleString('pt-BR')} sc`;
		},
		motorClass(motor) {
			const dark = this.theme === 'dark';
			if (motor.status == 1) return dark ? 'tw-bg-green-500/15 tw-text-green-400 tw-border-green-500/30' : 'tw-bg-green-50 tw-text-green-700 tw-border-green-200';
			return dark ? 'tw-bg-white/5 tw-text-gray-400 tw-border-white/10' : 'tw-bg-gray-100 tw-text-gray-500 tw-border-gray-200';
		},
		openInNewTab(unidadeId, siloId) {
			const route = this.$router.resolve(`/v2/unidades/${unidadeId}/silos/${siloId}`);
			window.open(route.href, '_blank');
		},
		abrirPopover(tipo, silo, event) {
			this.cancelarFechamentoPopover();
			this.popoverAncora = event.currentTarget;
			this.popover = { tipo, silo };
			this.popoverStyle = { visibility: 'hidden', top: '0px', left: '0px' };
			this.$nextTick(this.posicionarPopover);
		},
		posicionarPopover() {
			const el = this.$refs.popover;
			if (!el || !this.popoverAncora) return;
			const margem = 8;
			const r = this.popoverAncora.getBoundingClientRect();
			const vw = window.innerWidth, vh = window.innerHeight;
			const espacoAbaixo = vh - r.bottom - margem * 2;
			const espacoAcima = r.top - margem * 2;
			const abreAcima = el.scrollHeight > espacoAbaixo && espacoAcima > espacoAbaixo;
			const alturaMax = Math.max(80, abreAcima ? espacoAcima : espacoAbaixo);
			const altura = Math.min(el.scrollHeight, alturaMax);
			const largura = Math.min(el.offsetWidth, vw - margem * 2);
			const left = Math.min(Math.max(r.left + r.width / 2 - largura / 2, margem), vw - largura - margem);
			const top = abreAcima ? r.top - margem - altura : r.bottom + margem;
			this.popoverStyle = {
				top: `${top}px`,
				left: `${left}px`,
				maxHeight: `${alturaMax}px`,
				maxWidth: `${vw - margem * 2}px`
			};
		},
		agendarFechamentoPopover() {
			this.cancelarFechamentoPopover();
			this.popoverTimer = setTimeout(this.fecharPopover, 150);
		},
		cancelarFechamentoPopover() {
			if (this.popoverTimer) clearTimeout(this.popoverTimer);
			this.popoverTimer = null;
		},
		fecharPopover() {
			this.cancelarFechamentoPopover();
			this.popover = null;
			this.popoverAncora = null;
		}
	},
	data() {
		return {
			popover: null,
			popoverStyle: {},
		};
	},
	mounted() {
		this._fecharPopoverAoRolar = () => { if (this.popover) this.fecharPopover(); };
		window.addEventListener('scroll', this._fecharPopoverAoRolar, true);
		window.addEventListener('resize', this._fecharPopoverAoRolar);
		this._fecharPopoverAoClicarFora = (e) => {
			if (!this.popover) return;
			const el = this.$refs.popover;
			if (el && el.contains(e.target)) return;
			if (this.popoverAncora && this.popoverAncora.contains(e.target)) return;
			this.fecharPopover();
		};
		document.addEventListener('click', this._fecharPopoverAoClicarFora);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this._fecharPopoverAoRolar, true);
		window.removeEventListener('resize', this._fecharPopoverAoRolar);
		document.removeEventListener('click', this._fecharPopoverAoClicarFora);
		this.cancelarFechamentoPopover();
	},
	setup() {
		const store = useStore();
		const toast = useToast();
		const vue_app_name = process.env.VUE_APP_NAME;

		const unidades = ref([]);
		const unidadesSelecionadas = ref([]);
		const parametrosConsulta = ref([]);
		const loadingPage = ref(false);
		const resultUnidadesWithSilos = ref([]);
		const colunasTable = ref({});
		const consultaFeita = ref(false);

		const now = new Date();
		now.setHours(now.getHours() - 3);
		const dataInicial = ref(now.toISOString().slice(0, 16));
		const data = ref(dataInicial.value);

		const theme = computed(() => store.state.ui.theme);
		const cardClass = computed(() => theme.value === 'dark' ? 'tw-bg-[#1a1d21] tw-text-slate-200' : 'tw-bg-slate-50 tw-text-slate-700');
		const inputClass = computed(() => theme.value === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-white tw-text-slate-900');

		const TIPOS_COM_VALOR = ['contemsensores_>', 'contemsensores_<', 'mediaatual_>', 'mediaatual_<', 'nivel_>', 'nivel_<'];
		const COLUNAS = [
			{ key: 'nivel', label: 'Nível' },
			{ key: 'produto', label: 'Produto' },
			{ key: 'data_ultimo_registro', label: 'Data do registro' },
			{ key: 'media_atual', label: 'Média do grão' },
			{ key: 'status_motores', label: 'Status da aeração' },
		];
		const mostrarSensoresOff = computed(() => parametrosConsulta.value.some(p => p.tipo === 'contemcabosoff'));
		const mostrarSensoresMatch = computed(() => parametrosConsulta.value.some(p => p.tipo === 'contemsensores_<' || p.tipo === 'contemsensores_>'));

		const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

		const addParametroConsulta = () => {
			consultaFeita.value = false;
			parametrosConsulta.value.push({
				que_ou_quenao: "que",
				tipo: "",
				valor: null
			});
		};

		const removerParametro = (index) => {
			const param = parametrosConsulta.value[index];
			parametrosConsulta.value.splice(index, 1);
			if (param && param.tipo === "data==") {
				data.value = dataInicial.value;
			}
		};

		const adicionarUnidade = (id) => {
			const unidade = unidadesDisponiveis.value.find(u => u.id === id);
			if (unidade && !unidadesSelecionadas.value.some(u => u.id === unidade.id)) {
				unidadesSelecionadas.value.push(unidade);
			}
		};

		const removerUnidade = (id) => {
			unidadesSelecionadas.value = unidadesSelecionadas.value.filter(u => u.id !== id);
		};

		const selecionarTodasUnidades = () => {
			unidadesSelecionadas.value = [];
			unidadesSelecionadas.value = [...unidadesDisponiveis.value];
		};

		const limparUnidades = () => {
			unidadesSelecionadas.value = [];
		};

		const totalSilos = computed(() => {
			return resultUnidadesWithSilos.value.reduce((total, unidade) => total + (unidade.silos ? unidade.silos.length : 0), 0);
		});

		const unidadesDisponiveis = computed(() => {
			return unidades.value.filter(
				u => !unidadesSelecionadas.value.some(sel => sel.id === u.id)
			);
		});

		const executarConsulta = async () => {
			consultaFeita.value = false;
			loadingPage.value = true;
			if (unidadesSelecionadas.value.length === 0) {
				toast.error("Selecione pelo menos uma unidade.");
				loadingPage.value = false;
				return;
			}
			const ids = unidadesSelecionadas.value.map(u => u.id);
			const regras = parametrosConsulta.value
				.filter(param => param.tipo !== "data==")
				.map(param => {
				let str = param.que_ou_quenao;
				str += "_" + param.tipo + "_";
				str+= param.valor !== null ? param.valor : "0";
				return str;
			});
			let resultUnidades = await store.dispatch("unidades/fetchUnidadesConsultaAvancada", {ids, regras, data: data.value});
			resultUnidadesWithSilos.value = resultUnidades.filter(unidade => unidade.silos && unidade.silos.length > 0);
			loadingPage.value = false;
			consultaFeita.value = true;
			toast.success("Consulta executada com sucesso!");
		};

		onMounted(async () => {
			try {
				unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				if (unidades.value.length === 0) {
					await store.dispatch("unidades/fetchUnidades");
					unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				}
			} catch (error) {
				console.error("Erro ao buscar unidades:", error);
				toast.error("Erro ao buscar unidades");
			}
		});

		const queOptions = [
			{ label: 'que', value: 'que' },
			{ label: 'que não', value: 'quenao' },
		];
		const tipoOptions = [
			{ label: 'tenham leitura até', value: 'data==' },
			{ label: 'estejam com nível acima de', value: 'nivel_>' },
			{ label: 'estejam com nível abaixo de', value: 'nivel_<' },
			{ label: 'armazenem o produto', value: 'produto_==' },
			{ label: 'tenham média atual acima de', value: 'mediaatual_>' },
			{ label: 'tenham média atual abaixo de', value: 'mediaatual_<' },
			{ label: 'estejam com a aeração ligada', value: 'contemaeracaoligada' },
			{ label: 'tenham sensores em OFF', value: 'contemcabosoff' },
			{ label: 'tenham temperaturas acima de', value: 'contemsensores_>' },
			{ label: 'tenham temperaturas abaixo de', value: 'contemsensores_<' },
		];
		const produtoOptions = [
			'Vazio', 'Cevada', 'Feijão', 'Milho', 'Arroz', 'Sorgo', 'Soja', 'Trigo',
			'Canola', 'Azevém', 'Linhaça', 'Painço', 'Alpiste', 'Milheto', 'Aveia', 'Girassol', 'Outro',
		];

		return {
			unidades,
			unidadesSelecionadas,
			unidadesDisponiveis,
			cardClass,
			inputClass,
			TIPOS_COM_VALOR,
			COLUNAS,
			mostrarSensoresOff,
			mostrarSensoresMatch,
			vue_app_name,
			queOptions,
			tipoOptions,
			produtoOptions,
			parametrosConsulta,
			executarConsulta,
			loadingPage,
			resultUnidadesWithSilos,
			totalSilos,
			colunasTable,
			addParametroConsulta,
			removerParametro,
			adicionarUnidade,
			removerUnidade,
			selecionarTodasUnidades,
			limparUnidades,
			consultaFeita,
			getCorPorTemperatura,
			data,
			theme
		};
	},
};
</script>